import apiService from "../../services/api.service";
import { createSlice } from "@reduxjs/toolkit";
import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";

export const createOrder = createApiThunk(
  "createOrder",
  apiService.createOrder,
);

export const createIdentity = createApiThunk(
  "createIdentity",
  apiService.createIdentity,
);

export const createFinance = createApiThunk(
  "createFinance",
  apiService.createFinance,
);

export const createVso = createApiThunk("createVso", apiService.createVso);

export const createInsurance = createApiThunk(
  "createInsurance",
  apiService.createInsurance,
);

export const payOrder = createApiThunk("payOrder", apiService.payOrder);

export const getPaymentMethods = createApiThunk(
  "getPaymentMethods",
  apiService.getPaymentMethods,
);

export const getOrderList = createApiThunk(
  "getOrderList",
  apiService.getOrderList,
);

export const initialData = {
  createLoading: false,
  payOrderLoading: false,
  orderListLoading: false,
  paymentMethodsLoading: false,
  orderList: [
    // {
    //   id: "334902461",
    //   date: "16 Feb 2025 12:03 PM",
    //   status: "pending",
    //   total_item: 2,
    //   subtotal: 220.0,
    //   shipping: 0,
    //   tax: 0,
    //   total: 220.0,
    //   items: [
    //     {
    //       id: 1,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //     {
    //       id: 2,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //   ],
    // },
    // {
    //   id: "334902460",
    //   date: "14 Feb 2025 13:05 PM",
    //   status: "delivered",
    //   total_item: 2,
    //   subtotal: 220.0,
    //   shipping: 0,
    //   tax: 0,
    //   total: 220.0,
    //   items: [
    //     {
    //       id: 1,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //     {
    //       id: 2,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //   ],
    // },
  ],
  paymentMethods: {},
};

const dataSlice = createSlice({
  name: "order",
  initialState: initialData,
  reducers: {
    clearPaymentMethods: (state) => {
      state.paymentMethods = {};
    },
  },
  extraReducers: (builder) => {
    createApiCase(builder, createInsurance, {
      loading: "createLoading",
    });
    createApiCase(builder, createFinance, {
      loading: "createLoading",
    });
    createApiCase(builder, createVso, {
      loading: "createLoading",
    });
    createApiCase(builder, createIdentity, {
      loading: "createLoading",
    });
    createApiCase(builder, createOrder, {
      loading: "createLoading",
    });
    createApiCase(builder, payOrder, {
      loading: "payOrderLoading",
    });
    createApiCase(builder, getOrderList, {
      loading: "orderListLoading",
      fulfilled: (state, action) => {
        const data = action.payload?.data;

        state.orderList = Array.isArray(data?.aaData)
          ? data.aaData
          : Array.isArray(data?.orders)
            ? data.orders
            : Array.isArray(data)
              ? data
              : [];
      },
    });
    createApiCase(builder, getPaymentMethods, {
      loading: "paymentMethodsLoading",
      fulfilled: (state, action) => {
        state.paymentMethods =
          action.payload?.data?.channels || action.payload?.data || {};
      },
    });
  },
});

export const { clearPaymentMethods } = dataSlice.actions;

export default dataSlice.reducer;
